module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel.20699dc8.png";